
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"uberadmin"},{"kind":"EnumValue","value":"learner"}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deploymentHandle"},"value":{"kind":"StringValue","value":"stat","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"timepoint1"},"name":{"kind":"Name","value":"variableTimestamps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"total_sts_level_t1","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"%m/%d/%Y","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"timepoint2"},"name":{"kind":"Name","value":"variableTimestamps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"total_sts_level_t2","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"%m/%d/%Y","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"timepoint3"},"name":{"kind":"Name","value":"variableTimestamps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"total_sts_level_t3","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"%m/%d/%Y","block":false}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Intrusion1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Intrusion2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Intrusion3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Avoidance1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Avoidance2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Avoidance3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Arousal1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Arousal2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Arousal3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"STATTotal1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"STATTotal2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"STATTotal3"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":779}};
    doc.loc.source = {"body":"query($pawnId: [Int]) {\n    flows(as: [uberadmin, learner]) {\n        assignmentProgress(deploymentHandle: \"stat\", pawnId: $pawnId) {\n            timepoint1: variableTimestamps(name: \"total_sts_level_t1\", format: \"%m/%d/%Y\")\n            timepoint2: variableTimestamps(name: \"total_sts_level_t2\", format: \"%m/%d/%Y\")\n            timepoint3: variableTimestamps(name: \"total_sts_level_t3\", format: \"%m/%d/%Y\")\n            devTags {\n                Intrusion1\n                Intrusion2\n                Intrusion3\n                Avoidance1\n                Avoidance2\n                Avoidance3\n                Arousal1\n                Arousal2\n                Arousal3\n                STATTotal1\n                STATTotal2\n                STATTotal3\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
